
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({ components: {} })
export default class BaseDialog extends Vue {
  @Prop({
    type: Boolean,
    default: false,
  })
  public dialog!: boolean;

  @Prop({ type: String })
  public formTitle!: string;

  @Prop({ type: Function })
  public funcaoPrimaria!: Function;

  @Prop({ type: Function })
  public fecharModal!: Function;

  @Prop({
    type: String,
    default: 'Salvar',
  })
  public textBotaoPrimario!: string;

  @Prop({
    type: Boolean,
    default: false,
  })
  public hiddenBotaoPrimario!: boolean;

  @Prop({
    type: String,
    default: 'primary',
  })
  public colorBotaoPrimario!: string;

  async validarFormExecutarFuncaoPrimaria() {
    if ((this.$refs.formBaseDialog as HTMLFormElement).validate()) {
      await this.funcaoPrimaria()
        .then(() => {
          this.fecharResetarModal();
        });
    }
  }

  private fecharResetarModal() {
    (this.$refs.formBaseDialog as HTMLFormElement).reset();
    this.fecharModal();
  }
}
